import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-about-mountain-selfie.jpg`;
const ALT = "Lara and a grade-school friend laughing at the summit of a mountain, an American flag and wide valley behind them.";

export function MountainPerspective() {
  return (
    <section data-testid="about-mountain-perspective" className="relative overflow-hidden bg-[#FAFAF8]">
      <div className="relative w-full overflow-hidden reveal pb-10 lg:pb-0">
        {/* Desktop image half-band, left side, 45% — feathered on the inside (right) edge only, sky left to breathe */}
        <div className="hidden lg:block absolute inset-y-0 left-0 w-[49%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="mountain-perspective-image"
            bg="#FAFAF8"
            objectPosition="55% 55%"
            featherRight={40}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/5] mt-2">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="mountain-perspective-image-mobile"
            bg="#FAFAF8"
            objectPosition="55% 50%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean right, 55% */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-8 lg:pt-0 flex items-center justify-end lg:min-h-[min(64vh,540px)]">
          <div className="w-full lg:w-[51%]">
            <div className="max-w-[540px] lg:ml-auto">
              <p
                data-testid="mountain-perspective-header"
                className="font-display text-[26px] md:text-[34px] text-[#1C1917] leading-[1.25] mb-5"
              >
                I&rsquo;ve driven past that mountain hundreds of times.
              </p>
              <div
                data-testid="mountain-perspective-body"
                className="space-y-3 text-lg md:text-xl leading-relaxed text-[#57534E]"
              >
                <p>It&rsquo;s always there.</p>
                <p>Always beautiful.</p>
                <p>
                  Always something I&rsquo;d get around to &ldquo;one
                  day.&rdquo;
                </p>
                <p>
                  Then one summer in my 40s, a grade school friend and I
                  decided to stop driving past it and climb it.
                </p>
                <p>
                  Turns out, it wasn&rsquo;t nearly as hard as I&rsquo;d
                  imagined.
                </p>
                <p>We took this picture.</p>
                <p>Started back down carefully.</p>
                <p>And yes &hellip; I still managed to fall.</p>
                <p>
                  Apparently gravity doesn&rsquo;t care whether the hike is
                  difficult.
                </p>
                <p>
                  Since that day, I&rsquo;ve caught myself wondering what else
                  I&rsquo;ve built up in my mind that is simply waiting for me
                  to begin.
                </p>
                <p>
                  It also makes me giggle, remembering all the other times
                  I&rsquo;ve fallen &hellip;
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
